import { render } from "./IconPlus.vue?vue&type=template&id=7aa8828b&scoped=true"
import script from "./IconPlus.vue?vue&type=script&lang=js"
export * from "./IconPlus.vue?vue&type=script&lang=js"

import "./IconPlus.vue?vue&type=style&index=0&id=7aa8828b&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aa8828b"]])

export default __exports__